export default {
  GET_TRANSPORT: state => state.transport,
  GET_TRANSPORT_CATEGORY: state => state.transport_category,
}
